var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/WikiEntryDraft.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { DataLoadedField } from "@adornis/baseql/decorators/data-loaded-field.js";
import "@adornis/baseql/utils/queryGeneration.js";
import { validate } from "@adornis/validation/decorators.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
import { WikiEntry } from "./WikiEntry.js";
var WikiEntryDraftStatus = /* @__PURE__ */ ((WikiEntryDraftStatus2) => {
  WikiEntryDraftStatus2["IN_EDIT"] = "In Bearbeitung";
  WikiEntryDraftStatus2["IN_REVIEW"] = "\xDCberpr\xFCfung";
  WikiEntryDraftStatus2["DONE"] = "Fertig";
  WikiEntryDraftStatus2["OTHERS"] = "Sonstiges";
  return WikiEntryDraftStatus2;
})(WikiEntryDraftStatus || {});
var WikiEntryDraft = class extends WikiEntry {
  static ConvertToDraft(entry) {
    return new WikiEntryDraft({
      title: entry.title,
      content: entry.content,
      parentID: entry.parentID,
      writePermission: entry.writePermission,
      readPermission: entry.readPermission,
      _id: void 0,
      _class: "WikiEntryDraft",
      referenceID: entry._id,
      status: "IN_EDIT"
    });
  }
  static async ConvertToDraftByID(entryID) {
    const parent = await WikiEntry.getByID(entryID)({
      _id: 1,
      content: 1,
      title: 1,
      parentID: 1,
      writePermission: 1,
      readPermission: 1
    });
    if (!parent)
      return;
    return WikiEntryDraft.ConvertToDraft(parent);
  }
  static async beforeCreate(entity) {
    return WikiEntry.beforeCreate(entity);
  }
  static async afterCreate(entity, result) {
    await WikiEntry.afterCreate(entity, result);
  }
  static async transformBeforeUpdate(oldEntity, update) {
    await WikiEntry.transformBeforeUpdate(oldEntity, update);
  }
  static async afterUpdate(oldEntity, newEntity, result) {
    await WikiEntry.afterUpdate(oldEntity, newEntity, result);
  }
  static async afterRemove(id, entityData) {
    await WikiEntry.afterRemove(id, entityData);
  }
};
WikiEntryDraft._class = "WikiEntryDraft";
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], WikiEntryDraft.prototype, "status", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], WikiEntryDraft.prototype, "referenceID", 2);
__decorateClass([
  DataLoadedField((type) => WikiEntry, ({ referenceID }) => referenceID)
], WikiEntryDraft.prototype, "entry", 2);
WikiEntryDraft = __decorateClass([
  Entity()
], WikiEntryDraft);
export {
  WikiEntryDraft,
  WikiEntryDraftStatus
};
